module.exports = __webpack_public_path__ + "static/media/opensans-bold.646188c0.woff2";